import React from 'react';
import cs from 'clsx';

import { Icon } from './icon';

export const FlipCard = ({ item, className, active, hasBackground }) => (
    <div className={cs('flip-card', className, { active })}>
        <div className="flip-card-inner">
            <div className="flip-card-front">
                <Icon name={item.icon} showCircle={!hasBackground} />
                <div className="separator" />
                <span className="label" dangerouslySetInnerHTML={{ __html: item.headline }} />
                <div className="separator" />
                <div className={cs('amount', { 'long': item.total.length > 10 })}>
                    {item.total}
                </div>
            </div>
        </div>
    </div>
);

export default FlipCard;
